import { render } from "./EditBallot.vue?vue&type=template&id=6ad08008&scoped=true"
import script from "./EditBallot.vue?vue&type=script&lang=ts"
export * from "./EditBallot.vue?vue&type=script&lang=ts"

import "./EditBallot.vue?vue&type=style&index=0&id=6ad08008&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6ad08008"

export default script